module.exports = __webpack_public_path__ + "img/d_1.11edb4d3.png";